import React from 'react'
import {
  DashboardOutlined,
  ShoppingCartOutlined,
  RollbackOutlined,
  CloseCircleOutlined,
  AppstoreOutlined,
  DollarOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons'
import { Menu } from 'antd'
import { type TreeMenuItem, useLink } from '@refinedev/core'

const ICON_MAP: Record<string, React.ReactNode> = {
  dashboard: <DashboardOutlined />,
  'order-management': <ShoppingCartOutlined />,
  'return-management': <RollbackOutlined />,
  'cancellation-management': <CloseCircleOutlined />,
  'product-management': <AppstoreOutlined />,
  'settlement-management': <DollarOutlined />,
}

export function BuildDealerMenuItems({
  tree,
  selectedKey,
}: {
  tree: TreeMenuItem[]
  selectedKey?: string
}): React.ReactNode[] {
  const Link = useLink()

  const renderTree = (items: TreeMenuItem[]): React.ReactNode[] =>
    items.map((item) => {
      const { key, name, children, meta, list } = item
      const label = item.label ?? meta?.label ?? name
      const icon =
        ICON_MAP[name] ??
        meta?.icon ??
        (children.length > 0 ? <UnorderedListOutlined /> : undefined)

      if (children.length > 0) {
        return (
          <Menu.SubMenu key={key} icon={icon} title={label} data-testid={`nav-submenu-${name}`}>
            {renderTree(children)}
          </Menu.SubMenu>
        )
      }

      const isSelected = key === selectedKey

      return (
        <Menu.Item key={key} icon={icon} data-testid={`nav-item-${name}`}>
          <Link to={list ?? ''}>{label}</Link>
          {isSelected && <div className="ant-menu-tree-arrow" />}
        </Menu.Item>
      )
    })

  return renderTree(tree)
}
